import { Text } from '@nike/eds'
import { PropsWithChildren } from 'react'
import { UniqueTruncatedTooltip } from '../../utils/formatter'

interface FieldProps {
  list?: any[]
  label: any
  style?: any
}

export function DetailsField({ list, children, label, style }: PropsWithChildren<FieldProps>) {
  return (
    <div style={{ margin: '10px', ...style }}>
      <Text className="details-label" font={'body-2'} as="label">
        {label}
      </Text>
      <Text className="details-value" font={'title-6'} as="div">
        {list ? (
          <div> {list.length > 1 ? UniqueTruncatedTooltip(list, 'bottom-start') : list[0]}</div>
        ) : (
          <span>{children}</span>
        )}
      </Text>
    </div>
  )
}
